var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilIkonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.71 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19.85,
    cy: 11.78,
    r: 11.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.85,25.09h0c10.96,0,19.85,8.9,19.85,19.85v1.98c0,3.9-3.17,7.07-7.07,7.07H7.07C3.17,54,0,50.83,0,46.93v-1.98C0,33.99,8.9,25.09,19.85,25.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilIkonWhite);
export default __webpack_public_path__ + "static/media/Profil_Ikon_white.a31af46fd5c1a660a94fa6820d35c37d.svg";
export { ForwardRef as ReactComponent };